module.exports = __webpack_public_path__ + "static/media/instagram.afa966ad.png";